module.exports = __webpack_public_path__ + "static/media/slider2023-03.51c754d2.jpg";